<template>
  <b-row class="sales-reports-tab-kpis mb-3">
    <b-col
      v-for="(card, index) in cards"
      :key="index"
      cols="6"
      lg="3"
      class="mb-2 mb-lg-0"
    >
      <div class="kpi-card lov-card">
        <small class="kpi-label">{{ card.label }}</small>
        <div
          class="kpi-value"
          :class="toneClass(card.tone)"
        >
          {{ card.value }}
        </div>
        <small
          v-if="card.hint"
          class="kpi-hint"
        >{{ card.hint }}</small>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'SalesReportsTabKpis',
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    toneClass(tone) {
      return {
        'kpi-value--primary': tone === 'primary',
        'kpi-value--success': tone === 'success',
        'kpi-value--warning': tone === 'warning',
        'kpi-value--danger': tone === 'danger',
      };
    },
  },
};
</script>

<style scoped>
.kpi-card {
  height: 100%;
  padding: 1rem 1.1rem;
}
.kpi-label {
  color: #6b7280;
  font-size: 12px;
  display: block;
  margin-bottom: 6px;
}
.kpi-value {
  font-size: 1.35rem;
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}
.kpi-value--primary {
  color: #2563eb;
}
.kpi-value--success {
  color: #16a34a;
}
.kpi-value--warning {
  color: #ea580c;
}
.kpi-value--danger {
  color: #dc2626;
}
.kpi-hint {
  color: #9ca3af;
  font-size: 11px;
  display: block;
  margin-top: 4px;
}
.lov-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}
</style>
